import { ReactComponent as CheckedIcon } from './checked-icon.svg'
export default CheckedIcon
